module.exports = __webpack_public_path__ + "img/topInfoImg.79d930df.png";